import {
  Alert,
  Box,
  Heading,
  Stack,
  Strong,
  Table,
  TableBody,
  TableCell,
  TableHeader,
  TableHeaderCell,
  TableRow,
  Text,
} from 'braid-design-system';
import { usePermissions } from '#src/hooks/auth.tsx';
import { useOrganizations } from '#src/pages/manage/organizations/OrganizationContext.tsx';
import { InvitationRow } from './components/InvitationRow.tsx';

export const InvitationList = () => {
  const { invitations, loading, error } = useOrganizations();
  const { permissions } = usePermissions();
  const hasWriteAccess = permissions.includes('mutate:users');

  if (loading) {
    return null;
  }

  if (error) {
    return (
      <Alert tone="critical">
        <Stack space="small">
          <Text>We couldn’t load the invitation list.</Text>
          <Text size="small">{error}</Text>
        </Stack>
      </Alert>
    );
  }

  return (
    <Stack space="gutter">
      <Heading level="2">Invitations</Heading>

      <Table label="Invitations">
        <TableHeader>
          <TableRow>
            <TableHeaderCell>
              <Text>Email</Text>
            </TableHeaderCell>
            <TableHeaderCell>
              <Text>Role</Text>
            </TableHeaderCell>
            <TableHeaderCell>
              <Text>Expires</Text>
            </TableHeaderCell>
            {hasWriteAccess ? (
              <TableHeaderCell>
                {
                  /* Actions */
                  null
                }
              </TableHeaderCell>
            ) : null}
          </TableRow>
        </TableHeader>

        <TableBody>
          {invitations.length > 0 ? (
            invitations.map((invitation) => (
              <InvitationRow
                key={`invitation-row-${invitation.id}`}
                invitation={invitation}
              />
            ))
          ) : (
            <TableRow>
              <TableCell colspan={4} align="center">
                <Box paddingY="large">
                  <Text>
                    No invitations to display. Click <Strong> Add User</Strong>{' '}
                    to invite a user to manage your integration.
                  </Text>
                </Box>
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </Stack>
  );
};
